import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Crown, Shield } from 'lucide-react';
import type { Subscription } from '../lib/hooks/useSubscription';

interface SubscriptionBadgeProps {
  type: Subscription;
}

const SubscriptionBadge: React.FC<SubscriptionBadgeProps> = ({ type }) => {
  if (type === 'free') return null;

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className={`
        inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium
        ${type === 'premium' 
          ? 'bg-purple-500/10 text-purple-500' 
          : type === 'admin'
          ? 'bg-red-500/10 text-red-500'
          : 'bg-primary/10 text-primary'
        }
      `}
    >
      {type === 'premium' ? (
        <Crown className="w-3 h-3" />
      ) : type === 'admin' ? (
        <Shield className="w-3 h-3" />
      ) : (
        <Zap className="w-3 h-3" />
      )}
      {type.charAt(0).toUpperCase() + type.slice(1)}
    </motion.div>
  );
};

export default SubscriptionBadge;
